export default {
  props: {
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    previousDisabled: {
      type: Boolean,
      default: false,
    },
    headerNavigation: {
      type: String,
      default: 'previous',
    },
    step: null,
    steps: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isStepEnabled(step) {
      if (step === this.step) {
        return true;
      }

      if (step > this.step
        && (
          this.nextDisabled
          || (
            this.steps[this.step].canForward
            && this.steps[this.step].canForward() === false
          )
        )
      ) {
        return false;
      }

      if (step < this.step && this.previousDisabled) {
        return false;
      }

      const stepConfig = this.steps[step];
      if (stepConfig && stepConfig.isDisabled) {
        return !stepConfig.isDisabled();
      }

      return true;
    },
    goToStep(index) {
      this.$emit('goToStep', index);
    },
  },
};
